export const SHOW_NAVBAR = "nav ACTION: SHOW";
export const HIDE_NAVBAR = "nav ACTION: HIDE"

export function showNavAction() {
  return {
    type: SHOW_NAVBAR,
  };
}

export function hideNavAction() {
    return {
      type: HIDE_NAVBAR,
    };
  }